import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CryptoService } from './crypto.service';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DataDecryptionIntercaptorService implements HttpInterceptor {
  constructor(private _CryptoService: CryptoService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // console.log('=== DECRYPTION INTERCEPTOR ===');
    // console.log('Request URL:', request.url);

    const urlsToSkip = [
      'get-ds-order-details',
      'pdas/get-inter-regional-order-tracking',
    ];
    if (urlsToSkip.some((skipUrl) => request.url.includes(skipUrl))) {
      // console.log('SKIPPING DECRYPTION for:', request.url);
      return next.handle(request).pipe(
        map((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            // console.log('SKIPPED RESPONSE - Raw response body:', event.body);
          }
          return event;
        })
      );
    }

    // console.log('PROCESSING DECRYPTION for:', request.url);

    // Clone the request and manipulate it if needed
    const modifiedRequest = request.clone({
      // Example: Adding a custom header
      setHeaders: {
        'X-Custom-Header': 'custom-value',
      },
    });

    return next.handle(modifiedRequest).pipe(
      map((event: HttpEvent<any>) => {
        // Manipulate response data here if needed
        // For example, modifying response body

        if (event instanceof HttpResponse) {
          // console.log('=== RESPONSE INTERCEPTED ===');
          // console.log('Response URL:', event.url);
          console.log(
            'Response body has obfuscated:',
            !!event?.body?.obfuscated
          );
          // Modify the response body here
          if (event?.body) {
            if (event?.body?.obfuscated) {
              // console.log('DECRYPTING RESPONSE for:', event.url);
              this._CryptoService.secretKey = this._CryptoService.getKey(
                event?.body?.obfuscated
              );
              const data = this._CryptoService.getData(event?.body?.obfuscated);
              // console.log(
              //   '---===-->',
              //   event.url,
              //   JSON.parse(
              //     JSON.parse(
              //       this._CryptoService.decryptData(
              //         data,
              //         this._CryptoService.secretKey
              //       )
              //     )
              //   )
              // );
              return event.clone({
                body: JSON.parse(
                  JSON.parse(
                    this._CryptoService.decryptData(
                      data,
                      this._CryptoService.secretKey
                    )
                  )
                ),
              });
            }
          }
          // Example: Adding a property to each item in the response array
        }

        return event;
      })
    );
  }
}
